import { useEffect, useRef } from "react";

/**
 * Custom blended cursor with grow state on interactive elements.
 * Uses refs + direct DOM mutation to avoid re-renders.
 */
export default function CustomCursor() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const move = (e) => {
      el.style.left = `${e.clientX}px`;
      el.style.top = `${e.clientY}px`;
    };
    const over = (e) => {
      const t = e.target;
      if (
        t.closest &&
        t.closest(
          "a, button, [data-cursor-grow], input, textarea, select, [role='button']",
        )
      ) {
        el.classList.add("cursor-grow");
      } else {
        el.classList.remove("cursor-grow");
      }
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden="true"
      data-testid="custom-cursor"
      className="custom-cursor"
      style={{ left: "-100px", top: "-100px" }}
    />
  );
}
